export default __webpack_public_path__ + "static/Logo_MissionMe_Bildmarke-373e0af571d38b4a37a98d17a3fb6222.svg";